/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupssubtitle1Inputs */

const en_signupssubtitle1 = /** @type {(inputs: Signupssubtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The newest accounts with the signals that say whether they are real people.`)
};

const de_signupssubtitle1 = /** @type {(inputs: Signupssubtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die neuesten Konten mit den Signalen, die zeigen, ob echte Menschen dahinterstehen.`)
};

/**
* | output |
* | --- |
* | "The newest accounts with the signals that say whether they are real people." |
*
* @param {Signupssubtitle1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupssubtitle1 = /** @type {((inputs?: Signupssubtitle1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupssubtitle1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupssubtitle1(inputs)
	return de_signupssubtitle1(inputs)
});
export { signupssubtitle1 as "signupsSubtitle" }